import {isNil} from "lodash";

export function erIkkeNill(verdi: any | null): boolean {
    return !erNill(verdi);
}

export function erNill(verdi: any | null): boolean {
    return isNil(verdi);
}

export function standard<T>(verdi: T | null, dersomNull: T): T {
    return erNill(verdi) ? dersomNull : verdi;
}
